export type ForecastMode = "Actual" | "Forecast" | "Mixed";

export interface ForecastReportYear {
	Year: number;
}

export interface ForecastReportMonth {
	Month: string;
	ForecastedProduction: number | null;
	ActualProduction: number | null;
	Number: number;
	Name: string;
	Year: number;
}

export interface ForecastReportAnalytics {
	ProductionYear: number;
	Mean: number | null;
	LastYearActualProduction: number | null;
	Increase: number | null;
	StandardDeviation: number | null;
	CoefficientOfVariation: number | null;
	Range: number | null;
	PRR: number | null;
	SamePeriodIncrease: number | null;
	SamePeriodMonths: number | null;
	SamePeriodLastMonth: number | null;
}

export interface ForecastReportData {
	years: ForecastReportYear[];
	monthly: ForecastReportMonth[];
	analytics: ForecastReportAnalytics[];
}

// The first four stay distinguishable on crossing lines, also for color-blind
// readers; from the fifth on, the line end labels tell the years apart
export const YEAR_COLOR_PALETTE = [
	"#2a78d6",
	"#e87ba4",
	"#008300",
	"#eda100",
	"#e34948",
	"#1baf7a",
	"#6250d6",
	"#eb6834",
] as const;
